import { render, staticRenderFns } from "./TinderTabMob.vue?vue&type=template&id=c05346c0&scoped=true"
import script from "./TinderTabMob.vue?vue&type=script&lang=js"
export * from "./TinderTabMob.vue?vue&type=script&lang=js"
import style0 from "./TinderTabMob.vue?vue&type=style&index=0&id=c05346c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05346c0",
  null
  
)

export default component.exports